import type { PreparedLocationHit } from '../types'

type Coords = PreparedLocationHit['_geoloc']

export function geoDistance(from: Coords, to: Coords): number {
  if (!from.lat || !from.lng || !to.lat || !to.lng) {
    return Number.POSITIVE_INFINITY
  }

  const lat1 = +from.lat
  const lon1 = +from.lng
  const lat2 = +to.lat
  const lon2 = +to.lng
  const p = 0.017453292519943295 // Math.PI / 180
  const c = Math.cos
  const a =
    0.5 -
    c((lat2 - lat1) * p) / 2 +
    (c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p))) / 2

  return 12742 * Math.asin(Math.sqrt(a)) // 2 * R; R = 6371 km
}
